import React from 'react';
import { Toaster } from 'react-hot-toast';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Skills from './components/Skills';
import Contact from './components/Contact';
import BlackHoleBackground from './components/BlackHoleBackground';

function App() {
  return (
    <div className="min-h-screen relative">
      <BlackHoleBackground />
      <div className="relative z-10">
        <Header />
        <main>
          <Hero />
          <About />
          <Skills />
          <Contact />
        </main>
      </div>
      <Toaster />
    </div>
  );
}

export default App;